import { render } from "./ForgotPassword.vue?vue&type=template&id=4332e7b2"
import script from "./ForgotPassword.js?vue&type=script&lang=js"
export * from "./ForgotPassword.js?vue&type=script&lang=js"

import "./ForgotPassword.scss?vue&type=style&index=0&lang=scss"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__